import Link from 'next/link'
import React from 'react'

const Tags = React.memo(
  ({ tassonomia = [], limitTemi = 3, limitDiscipline = 2, color = true, classes }) => {
    // TODO: da fare sulle chiavi degli attributi
    const classi = classes || ''

    let temi = []
    let discipline = []
    let t = tassonomia

    const attrTemi = t.find((item) => item.nome.toLowerCase().includes('tema'))
    if (attrTemi)
      temi = attrTemi.valori_attributi.slice(0, limitTemi).map((item, index) => {
        if (item.url)
          return (
            <Link legacyBehavior href={item.url} key={item.id}>
              <a className={`tags__item ${color ? 'u-color-brown' : ''}`}>
                {(index ? ', ' : '') + item.nome}
              </a>
            </Link>
          )
        else
          return (
            <span className={`tags__item ${color ? 'u-color-brown' : ''}`} key={item.id}>
              {(index ? ', ' : '') + item.nome}
            </span>
          )
      })

    const attrDiscipline = t.find((item) => item.nome.toLowerCase().includes('disciplina'))
    if (attrDiscipline)
      discipline = attrDiscipline.valori_attributi.slice(0, limitDiscipline).map((item, index) => {
        if (item.url)
          return (
            <Link legacyBehavior href={item.url} key={item.id}>
              <a className={`tags__item ${color ? 'u-color-teal' : ''}`}>
                {(index ? ', ' : '') + item.nome}
              </a>
            </Link>
          )
        else
          return (
            <span className={`tags__item ${color ? 'u-color-teal' : ''}`} key={item.id}>
              {(index ? ', ' : '') + item.nome}
            </span>
          )
      })

    return (
      <div className={`tags ${classi}`}>
        {temi}
        {temi.length && discipline.length ? (
          <span className={color ? 'u-color-brown' : ''}>{', '}</span>
        ) : null}
        {discipline}
      </div>
    )
  }
)

export default Tags
